import React, { useState } from 'react';
import { Box, Typography, Menu, MenuItem } from '@mui/material';
import logo from '../assets/swise_white.png';
import AvatarInitials from './AvatarInitials';
import { useNavigate } from 'react-router-dom';

interface Props {
  name: string;
}

const Header: React.FC<Props> = ({ name }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();

  const handleAvatarClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    sessionStorage.removeItem('authToken');
    navigate('/', { replace: true });
  };

  return (
    <Box
      sx={{
        backgroundColor: 'black',
        color: 'white',
        height: '100px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingX: 3,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={logo}
          alt="Swise Logo"
          style={{ width: '85px', marginRight: '10px' }}
        />
        <Typography variant="h5" sx={{ fontWeight: 'bold', marginTop: '6px' }}>
          VDR
        </Typography>
      </Box>

      <Box>
        <AvatarInitials name={name} onClick={handleAvatarClick} />
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default Header;